export default {
  SURVEYS_FETCHED: 'SURVEYS_FETCHED',
  SURVEY_LOAD: 'SURVEY_LOAD',
  SURVEY_SENT: 'SURVEY_SENT',
};
